// Frontend runs behind Cloudflare/nginx and proxies `/graphql` and `/file/*` to the backend.
// Defaulting to `localhost` breaks real users (it points to the user's own machine).
const defaultHost = typeof window !== 'undefined'
  ? window.location.origin
  : 'http://localhost:4000'

const host = process.env.REACT_APP_API_HOST || defaultHost
const endPoint = process.env.REACT_APP_API_ENDPOINT || 'graphql'

module.exports = {
  backend_url: host,
  endpoint: `${host}/${endPoint}`,
  fileEndpoint: `${host}/file`,
}
